/* ================================================================
   Meru House — Size Chart modal
   File: assets/mh-size-guide.js
   Markup: snippets/mh-size-guide.liquid

   THE CHART NUMBERS LIVE HERE (inches). Edit this block to change them.
   Source: Meru House garment-measurement charts (Oct 2026), all inches,
   sizes S / M / L / XL / XXL.

   Length rule: a style's garment length is the same in every size, and
   some products are cut longer or shorter than the house default. When a
   product's custom.specifications metafield states a length ("Length:" or
   "Top Length:"), that length is shown instead of the house default.
   Set USE_SPEC_LENGTH = false to always show the house default.
   ================================================================ */

(function () {
  'use strict';
  if (window.__mhSizeGuide) return;
  window.__mhSizeGuide = true;

  var USE_SPEC_LENGTH = true;
  var SIZES = ['S', 'M', 'L', 'XL', 'XXL'];

  var TOP = {
    chest: [38, 40, 42, 44, 46],
    waist: [36, 38, 40, 42, 44],
    hip: [42, 44, 46, 48, 50],
    shoulder: [15, 15.5, 16, 16.5, 17]
  };
  var PANTS = {
    waist: [27, 29, 31, 33, 35],
    hip: [43, 45, 47, 49, 51],
    thigh: [26, 27, 28, 29, 30],
    hem: [18, 19, 20, 21, 22],
    length: [38, 38.5, 39, 39.5, 40]
  };
  var JACKET = {
    chest: [40, 42, 44, 46, 48],
    shoulder: [15, 15.5, 16, 16.5, 17],
    length: [25, 25.5, 26, 26.5, 27]
  };

  function same(n) { return SIZES.map(function () { return n; }); }

  function topTable(title, length) {
    return {
      title: title,
      kind: 'grid',
      lengthCol: 5,
      cols: ['Chest', 'Waist', 'Hip', 'Shoulder', 'Length'],
      rows: [TOP.chest, TOP.waist, TOP.hip, TOP.shoulder, same(length)]
    };
  }
  function pantsTable(title) {
    return {
      title: title,
      kind: 'grid',
      cols: ['Waist', 'Hip', 'Thigh', 'Bottom (Hem)', 'Length'],
      rows: [PANTS.waist, PANTS.hip, PANTS.thigh, PANTS.hem, PANTS.length]
    };
  }
  function freeTable(title, length, breadth) {
    return { title: title, kind: 'free', lengthRow: 0, items: [['Length', length], ['Breadth', breadth]] };
  }

  var CHARTS = {
    'long-kurta': [topTable(null, 40)],
    'short-kurta': [topTable(null, 29)],
    'coord': [topTable('Top', 39), pantsTable('Pants')],
    'coord-short': [topTable('Top', 29), pantsTable('Pants')],
    'jacket': [{
      title: null,
      kind: 'grid',
      cols: ['Chest', 'Shoulder', 'Length'],
      rows: [JACKET.chest, JACKET.shoulder, JACKET.length]
    }],
    'kaftan': [freeTable('Free Size', 40, 40)],
    'kaftan-set': [freeTable('Kaftan · Free Size', 32, 40), pantsTable('Trousers')]
  };

  /* ── helpers ─────────────────────────────────────────────── */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(inches, unit) {
    var v = unit === 'cm' ? Math.round(inches * 2.54 * 10) / 10 : inches;
    return String(v);
  }
  // "L/42 Inches" -> "L", "XXL-46 Inches" -> "XXL"
  function cleanSize(s) {
    return String(s || '').split('/')[0].split('-')[0].trim().toUpperCase();
  }
  // First "Length:" / "Top Length:" value in the specifications text.
  function specLength(spec) {
    if (!spec) return null;
    var m = String(spec).match(/^\s*(?:top\s+)?length\s*:\s*([\d.]+)/im);
    return m ? parseFloat(m[1]) : null;
  }

  function cloneTables(key, spec) {
    var tables = JSON.parse(JSON.stringify(CHARTS[key] || []));
    var len = USE_SPEC_LENGTH ? specLength(spec) : null;
    if (len && tables.length) {
      var t = tables[0];
      if (t.kind === 'grid' && t.lengthCol != null) t.rows[t.lengthCol - 1] = same(len);
      if (t.kind === 'free') t.items[t.lengthRow][1] = len;
    }
    return tables;
  }

  function renderGrid(t, unit, selected) {
    var head = '<tr><th scope="col">Size</th>' +
      t.cols.map(function (c) { return '<th scope="col">' + esc(c) + '</th>'; }).join('') + '</tr>';
    var body = SIZES.map(function (size, i) {
      var sel = size === selected;
      return '<tr' + (sel ? ' class="is-selected"' : '') + '>' +
        '<th scope="row">' + size + (sel ? '<span class="visually-hidden"> (selected)</span>' : '') + '</th>' +
        t.rows.map(function (r) { return '<td>' + fmt(r[i], unit) + '</td>'; }).join('') +
        '</tr>';
    }).join('');
    return '<table class="mh-size-guide__table"><caption class="visually-hidden">' +
      esc(t.title || 'Size chart') + ', garment measurements in ' + (unit === 'cm' ? 'centimetres' : 'inches') +
      '</caption><thead>' + head + '</thead><tbody>' + body + '</tbody></table>';
  }

  function renderFree(t, unit) {
    return '<table class="mh-size-guide__table mh-size-guide__table--free"><caption class="visually-hidden">' +
      esc(t.title) + ', garment measurements in ' + (unit === 'cm' ? 'centimetres' : 'inches') + '</caption><tbody>' +
      t.items.map(function (it) {
        return '<tr><th scope="row">' + esc(it[0]) + '</th><td>' + fmt(it[1], unit) + '</td></tr>';
      }).join('') + '</tbody></table>';
  }

  function render(modal) {
    var st = modal.__mhsg;
    var html = st.tables.map(function (t) {
      return '<section class="mh-size-guide__group">' +
        (t.title ? '<h3 class="mh-size-guide__group-title">' + esc(t.title) + '</h3>' : '') +
        '<div class="mh-size-guide__table-wrap" tabindex="0">' +
        (t.kind === 'free' ? renderFree(t, st.unit) : renderGrid(t, st.unit, st.selected)) +
        '</div></section>';
    }).join('');
    modal.querySelector('[data-mh-sg-tables]').innerHTML = html;
    modal.querySelectorAll('[data-mh-sg-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mh-sg-unit') === st.unit ? 'true' : 'false');
    });
  }

  // The size currently picked on the page (falls back to the Liquid value).
  function currentSize(fallback) {
    var checked = document.querySelector('.mh-size-scale--pdp input[type="radio"]:checked');
    if (checked) return cleanSize(checked.value);
    return cleanSize(fallback);
  }

  function setup(modal) {
    if (modal.__mhsg) return modal.__mhsg;
    var data = {};
    try {
      data = JSON.parse(modal.querySelector('[data-mh-sg-source]').textContent);
    } catch (e) {}
    var unit = 'in';
    try { unit = localStorage.getItem('mhSizeUnit') || 'in'; } catch (e) {}
    modal.__mhsg = { key: data.key, size: data.size, unit: unit, tables: cloneTables(data.key, data.spec) };

    modal.addEventListener('click', function (e) {
      var u = e.target.closest('[data-mh-sg-unit]');
      if (u) {
        modal.__mhsg.unit = u.getAttribute('data-mh-sg-unit');
        try { localStorage.setItem('mhSizeUnit', modal.__mhsg.unit); } catch (err) {}
        render(modal);
        return;
      }
      if (e.target.closest('[data-mh-size-guide-close]')) close();
    });
    return modal.__mhsg;
  }

  var open = null; // { modal, trigger }

  function onKey(e) {
    if (!open) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') { // keep focus inside the dialog
      var f = open.modal.querySelectorAll('button, [tabindex="0"]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  }

  function show(modal, trigger) {
    // The size row is a CSS container (contain: layout), which would trap a
    // position:fixed dialog inside it, so the dialog lives on <body>.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    var st = setup(modal);
    st.selected = currentSize(st.size);
    render(modal);
    modal.hidden = false;
    document.body.classList.add('mh-size-guide-open');
    open = { modal: modal, trigger: trigger };
    document.addEventListener('keydown', onKey);
    var c = modal.querySelector('.mh-size-guide__close');
    if (c) c.focus();
  }

  function close() {
    if (!open) return;
    open.modal.hidden = true;
    document.body.classList.remove('mh-size-guide-open');
    document.removeEventListener('keydown', onKey);
    if (open.trigger && document.contains(open.trigger)) open.trigger.focus();
    open = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mh-size-guide-open]');
    if (!t) return;
    var modal = document.getElementById('mh-size-guide-' + t.getAttribute('data-mh-size-guide-open'));
    if (modal) { e.preventDefault(); show(modal, t); }
  });

  window.MHSizeGuide = { charts: CHARTS, sizes: SIZES };
})();
